import { ValidateField, ExponentialToDecimal, FieldHasValue } from 'helpers/Validation';

export const AsFoundTestTableDeviationEu1Formula = (formData) => FieldHasValue(formData.F650asFoundTripPoint) && FieldHasValue(formData.F1055AftObservedTripSetpoint)
    ? ExponentialToDecimal(Math.abs(ValidateField(formData.F650asFoundTripPoint) - ValidateField(formData.F1055AftObservedTripSetpoint))) : '';
